import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { SubscriptionStepperState } from "../../subscriptions/subscription-stepper-state.service";
import { Plan } from "@common/core/types/models/Plan";
import { CurrentUser } from "@common/auth/current-user";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { SortPipe } from "./sort-pipe";

export interface pData {
  amount: number;
}

@Component({
  selector: "select-plan-panel",
  templateUrl: "./select-plan-panel.component.html",
  styleUrls: ["./select-plan-panel.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectPlanPanelComponent implements OnInit {
  // register = true;
  public hasRecommendedPlan = false;
  @Input() year;
  @Input() cur;

  @Output() selected = new EventEmitter();

  jioemail: {
    email: "";
  };
  jio: {
    item_price_id: "";
  };
  passData = [];
  savedPlan: any;
  isUserRegistered: boolean = false;
  chargebeeUrl: any;
  defaultPlan: any = [];
  selectedYear: any;
  selectedCru: any;
  constructor(
    public state: SubscriptionStepperState,
    public currentUser: CurrentUser,
    public router: Router,
    private http: HttpClient,
    public route: ActivatedRoute,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) // public sort: SortPipe
  {}

  ifRegistered() {
    let returnval = false;
    if (this.route.snapshot?.queryParams?.item_price_id) {
      returnval = true;
    }
    return returnval;
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("changes", changes);
    if (changes.cur) {
      this.selectedCru = changes.cur.currentValue;
      this.getAllPlans();
    }
    if (changes.year) {
      this.selectedYear = changes.year.currentValue;
      this.getAllPlans();
    }
  }

  ngOnInit() {
    this.getAllPlans();
   
    this.savedPlan = JSON.parse(localStorage.getItem("selectedPlan"));

    if (this.savedPlan) {
      localStorage.removeItem("selectedPlan");
    }

    this.hasRecommendedPlan =
      this.state.plans.filter((plan) => plan.recommended).length > 0;
  }

  public selectPlan(plan: Plan) {
    // localStorage.setItem("selectedPlan", JSON.stringify(plan));
    // console.log(plan);
    this.state.selectInitialPlan(plan);
    this.selected.emit(plan);

    // below code was commented because it didnt work as per prev developer shit logic

    // this.router.navigate(["/register"], {
    //   queryParams: {
    //     email: "",
    //     item_price_id: "cbdemo_lite-INR-yearly",
    //   },
    // });

    // this.router.navigateByUrl('/register')
    // this.state.selectInitialPlan(plan);
    // fire event on next render to avoid race conditions
    // setTimeout(() => this.selected.emit(plan));
    // this.selected.emit(plan);
  }

  public getAllPlans() {
    this.defaultPlan = [];
    console.log("planData", this.selectedCru);
    console.log("year", this.selectedYear);
    console.log("state-plan-2", this.state.plans);
    this.state.plans.forEach((pl) => {
      if (!this.selectedCru && !this.selectedYear) {
        if (pl.currency === "INR" && pl.interval === "month") {
          this.defaultPlan.push(pl);
        }
      }
      if (this.selectedCru && !this.selectedYear) {
        if (pl.currency === this.selectedCru && pl.interval === "month") {
          this.defaultPlan.push(pl);
        }
      }
      if (!this.selectedCru && this.selectedYear) {
        if (
          pl.currency === "INR" &&
          pl.interval === this.selectedYear.toLowerCase()
        ) {
          this.defaultPlan.push(pl);
        }
      }
      if (this.selectedCru && this.selectedYear) {
        if (
          pl.currency === this.selectedCru &&
          pl.interval === this.selectedYear.toLowerCase()
        ) {
          this.defaultPlan.push(pl);
        }
      }
    });
    this.sortPlans();
    console.log("this.defaultPlan", this.defaultPlan);
  }

  public userSubscribedToPlan(plan: Plan): boolean {
    if (
      this.state.mode !== "pricing" &&
      plan.free &&
      (!this.currentUser.model$?.value?.subscriptions?.length 
        || !this.currentUser.isProUser())
    ) {
      return true;
    }
    return !!this.currentUser.getSubscription({ planId: plan.id });
  }

  public selectPlanButtonText(plan: Plan) {
    if (this.userSubscribedToPlan(plan)) {

      return "Your Current Plan";
    } 
    else if (this.currentUser.isLoggedIn() && 
            plan.free && this.state.mode === "pricing") {

      return "Get Started";
    } 
    else {
      
      return "Choose Plan";
    }
  }

  shouldDisablePlanSelection(plan: Plan) {

    if (this.userSubscribedToPlan(plan)) {

      return true;
    } 
    else if (this.currentUser.isLoggedIn() && 
            plan.free && this.state.mode === "pricing") {

      return true;
    } 
    return false;
  }


  sortPlans(){
    this.defaultPlan = this.defaultPlan.sort(
        (low: pData, high: pData) => +low.amount - +high.amount
      );
  }
}
